import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./gateway.js";
//#region src/gateway_helper.ts
var gateway_helper_exports = /* @__PURE__ */ __exportAll({
	isCampusCard: () => isCampusCard,
	isCashMachine: () => isCashMachine,
	name: () => name
});
function name(gateway) {
	switch (gateway) {
		case 25: return "Adyen";
		case 51: return "Appfront";
		case 10: return "Archer";
		case 43: return "Atrium (Loyalty)";
		case 9: return "Atrium (SV)";
		case 3: return "CardConnect";
		case 32: return "CBORD (SV)";
		case 38: return "Chase";
		case 28: return "Chopt Loyalty";
		case 30: return "Como";
		case 1: return "CreditCall";
		case 54: return "eCard Systems";
		case 24: return "Eigen";
		case 27: return "Eigen Stored Value";
		case 20: return "Elavon";
		case 12:
		case 13: return "FreedomPay";
		case 50: return "FreedomPay (SV)";
		case 7: return "Givex";
		case 53: return "Givex Loyalty";
		case 44: return "Glory";
		case 8: return "Heartland";
		case 6: return "LevelUp";
		case 46: return "Love's Rewards";
		case 41: return "Moneris";
		case 0: return "NoGateway";
		case 17: return "OLOGift";
		case 22: return "Olo Pay Kiosk (Ordering API)";
		case 33: return "Olo Pay Kiosk (Payment API)";
		case 37: return "Par Pay";
		case 16: return "Paytronix";
		case 47: return "Pinata Campus Card";
		case 45: return "Pinata Cash Machine";
		case 36: return "Pinata Loyalty";
		case 29: return "Pinata Pay";
		case 31: return "Pinata Pay Native";
		case 14: return "PinataStoredValue";
		case 35: return "Punchh";
		case 48: return "Quickcharge";
		case 39: return "Smooth Commerce";
		case 40: return "Spendgo";
		case 2: return "Square";
		case 42: return "Starbucks";
		case 49: return "Starbucks (Stored Value)";
		case 11:
		case 23: return "Stripe";
		case 4: return "TCC";
		case 34: return "Thanx";
		case 52: return "Transact Campus Card";
		case 15: return "Valutec";
		case 21: return "Verifone Point Cloud";
		case 26: return "Verifone Point SCA";
		case 5: return "Worldpay";
	}
}
function isCashMachine(gateway) {
	switch (gateway) {
		case 45:
		case 44: return true;
		case 25:
		case 51:
		case 10:
		case 43:
		case 9:
		case 3:
		case 32:
		case 38:
		case 28:
		case 30:
		case 1:
		case 54:
		case 24:
		case 27:
		case 20:
		case 12:
		case 13:
		case 50:
		case 7:
		case 53:
		case 8:
		case 6:
		case 46:
		case 41:
		case 0:
		case 17:
		case 22:
		case 33:
		case 37:
		case 16:
		case 47:
		case 36:
		case 29:
		case 31:
		case 14:
		case 35:
		case 48:
		case 39:
		case 40:
		case 2:
		case 42:
		case 49:
		case 11:
		case 23:
		case 4:
		case 34:
		case 52:
		case 15:
		case 21:
		case 26:
		case 5: return false;
	}
}
function isCampusCard(gateway) {
	switch (gateway) {
		case 32:
		case 47:
		case 48:
		case 52: return true;
		case 25:
		case 51:
		case 10:
		case 43:
		case 9:
		case 3:
		case 38:
		case 28:
		case 30:
		case 1:
		case 54:
		case 24:
		case 27:
		case 20:
		case 12:
		case 13:
		case 50:
		case 7:
		case 53:
		case 44:
		case 8:
		case 6:
		case 46:
		case 41:
		case 0:
		case 17:
		case 22:
		case 33:
		case 37:
		case 16:
		case 45:
		case 36:
		case 29:
		case 31:
		case 14:
		case 35:
		case 39:
		case 40:
		case 2:
		case 42:
		case 49:
		case 11:
		case 23:
		case 4:
		case 34:
		case 15:
		case 21:
		case 26:
		case 5: return false;
	}
}
//#endregion
export { gateway_helper_exports, isCampusCard, isCashMachine, name };

//# sourceMappingURL=gateway_helper.js.map